(() => {
  function initializeGolfConfigurator(configurator) {
    if (!configurator || configurator.dataset.initialized === 'true') {
      return;
    }

    configurator.dataset.initialized = 'true';

    const pricePerIron = Number(
      configurator.dataset.pricePerIron || 0
    );

const currency =
  configurator.dataset.currency || 'USD';

const shaftDataElement = configurator.querySelector(
  '[data-gc-shaft-data]'
);

let shafts = [];

try {
  shafts = JSON.parse(
    shaftDataElement?.textContent || '[]'
  );
} catch (error) {
  console.error('Unable to load shaft data:', error);
}
const gripDataElement = configurator.querySelector(
  '[data-gc-grip-data]'
);

let grips = [];

try {
  grips = JSON.parse(
    gripDataElement?.textContent || '[]'
  );
} catch (error) {
  console.error('Unable to load grip data:', error);
}

console.log('Grips loaded:', grips);

const pricingDataElement = document.querySelector(
  '[data-gc-pricing-products]'
);

let pricingProducts = null;

if (pricingDataElement) {
  try {
    pricingProducts = JSON.parse(pricingDataElement.textContent || '{}');
  } catch (error) {
    console.error('Unable to load configurator pricing products:', error);
  }
}

console.log('Configurator pricing products:', pricingProducts);

const gripState = {
  brand: null,
  grip: null,
  size: null,
  installation: null
};

const shaftState = {
    manufacturer: null,
    shaft: null,
    flex: null,
    length: null
};
const defaultShaftManufacturer =
  configurator.dataset.defaultShaftManufacturer || '';

const defaultShaftName =
  configurator.dataset.defaultShaft || '';

const defaultGripBrand =
  configurator.dataset.defaultGripBrand || '';

const defaultGripName =
  configurator.dataset.defaultGrip || '';

const shaftManufacturerSelect = configurator.querySelector(
  '[data-shaft-manufacturer]'
);

const shaftSelect = configurator.querySelector(
  '[data-shaft-select]'
);
const shaftImageContainer = configurator.querySelector(
  '[data-shaft-image]'
);
const flexOptionsContainer = configurator.querySelector(
  '[data-flex-options]'
);

const shaftLengthSelect = configurator.querySelector(
  '[data-shaft-length-select]'
);
const continueToGripButton = configurator.querySelector(
  '[data-continue-to-grip]'
);
const gripBrandSelect = configurator.querySelector(
  '[data-grip-brand-select]'
);

const gripSelect = configurator.querySelector(
  '[data-grip-select]'
);

const gripImageContainer = configurator.querySelector(
  '[data-grip-image]'
);

const gripSizeOptionsContainer = configurator.querySelector(
  '[data-grip-size-options]'
);

const gripInstallationOptionsContainer =
  configurator.querySelector(
    '[data-grip-installation-options]'
  );
function getGripBrands() {
  return [
    ...new Set(
      grips
        .map((grip) => String(grip.brand || '').trim())
        .filter(Boolean)
    )
  ];
}
function populateGripBrandOptions() {
  if (!gripBrandSelect) return;

  const brands = getGripBrands();

  gripBrandSelect.innerHTML = '';

  brands.forEach((brand) => {
    const option = document.createElement('option');

    option.value = brand;
    option.textContent = brand;

    gripBrandSelect.appendChild(option);
  });

  const configuredDefaultGrip = grips.find(
  (grip) =>
    String(grip.grip_name || '')
      .trim()
      .toLowerCase() ===
    defaultGripName.trim().toLowerCase()
);

const brandFromDefaultGrip =
  configuredDefaultGrip?.brand || '';

const startingBrand =
  brandFromDefaultGrip ||
  brands.find(
    (brand) =>
      brand.toLowerCase() ===
      defaultGripBrand.trim().toLowerCase()
  ) ||
  brands[0] ||
  '';

  gripBrandSelect.value = startingBrand;
  gripState.brand = startingBrand;
  
populateGripOptions(
  startingBrand,
  defaultGripName
);
}

function populateGripOptions(
  brand,
  preferredGripName = ''
) {
  if (!gripSelect) return;

  const matchingGrips = grips
    .filter(
      (grip) =>
        String(grip.brand || '').trim() ===
        String(brand || '').trim()
    )
    .sort(
      (a, b) =>
        Number(a.sort_order || 9999) -
        Number(b.sort_order || 9999)
    );

  gripSelect.innerHTML = '';

  matchingGrips.forEach((grip) => {
    const gripName = String(
      grip.grip_name || ''
    ).trim();

    if (!gripName) return;

    const option =
      document.createElement('option');

    option.value = gripName;

const gripUpcharge =
  getGripUpcharge(grip);

if (gripUpcharge > 0) {
  const formattedUpcharge =
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(gripUpcharge);

  option.textContent =
    `${gripName} (+${formattedUpcharge} per club)`;
} else {
  option.textContent = gripName;
}

    gripSelect.appendChild(option);
  });

  const preferredGrip = matchingGrips.find(
    (grip) =>
      String(grip.grip_name || '')
        .trim()
        .toLowerCase() ===
      String(preferredGripName || '')
        .trim()
        .toLowerCase()
  );

  const startingGripName =
    preferredGrip?.grip_name ||
    matchingGrips[0]?.grip_name ||
    '';

  gripSelect.value = startingGripName;

  gripState.grip =
    matchingGrips.find(
      (grip) =>
        String(grip.grip_name || '').trim() ===
        String(startingGripName || '').trim()
    ) || null;

  gripState.size = null;
  gripState.installation = null;

  renderGripDependentOptions();
}

function renderSelectedGrip() {
  if (!gripImageContainer) return;

  gripImageContainer.innerHTML = '';

  const selectedGrip = gripState.grip;

  if (!selectedGrip?.image_url) {
    gripImageContainer.hidden = true;
    return;
  }

  const image = document.createElement('img');

  image.src = selectedGrip.image_url;
  image.alt =
    selectedGrip.grip_name || 'Selected grip';
  image.loading = 'lazy';

  gripImageContainer.appendChild(image);
  gripImageContainer.hidden = false;
}

function renderGripSizeOptions() {
  if (!gripSizeOptionsContainer) return;

  gripSizeOptionsContainer.innerHTML = '';

  const sizes = Array.isArray(
    gripState.grip?.available_grip_sizes
  )
    ? gripState.grip.available_grip_sizes
    : [];

  if (!sizes.length) {
    gripState.size = null;
    gripSizeOptionsContainer.hidden = true;
    return;
  }

  const selectedSize =
    sizes.includes(gripState.size)
      ? gripState.size
      : sizes[0];

  gripState.size = selectedSize;
  gripSizeOptionsContainer.hidden = false;

  sizes.forEach((size) => {
    const label = document.createElement('label');
    label.className = 'gc-choice-card';

    const input = document.createElement('input');
    input.type = 'radio';
    input.name = 'gc-grip-size';
    input.value = size;
    input.dataset.gripSizeValue = size;
    input.checked = size === selectedSize;

    const content = document.createElement('span');
    content.className = 'gc-choice-card__content';
    content.textContent = size;

    label.appendChild(input);
    label.appendChild(content);

    input.addEventListener('change', () => {
      if (!input.checked) return;

      gripState.size = size;

      gripSizeOptionsContainer
        .querySelectorAll('input[type="radio"]')
        .forEach((radio) => {
          radio.checked =
            radio.dataset.gripSizeValue === size;
        });
    });

    gripSizeOptionsContainer.appendChild(label);
  });
}

function renderGripInstallationOptions() {
  if (!gripInstallationOptionsContainer) return;

  gripInstallationOptionsContainer.innerHTML = '';

  const selectedGrip = gripState.grip;

  if (!selectedGrip) {
    gripState.installation = null;
    return;
  }

  const methods = Array.isArray(
    selectedGrip.available_installation_methods
  )
    ? selectedGrip.available_installation_methods
    : [];

  gripState.installation =
    methods.includes(gripState.installation)
      ? gripState.installation
      : methods[0] || null;

  methods.forEach((method) => {
    const button = document.createElement('button');

    button.type = 'button';
    button.className =
      'button button--secondary gc-option-button';
    button.textContent = method;
    button.dataset.gripInstallationValue = method;

    const buttonIsSelected =
      gripState.installation === method;

    button.classList.toggle(
      'is-selected',
      buttonIsSelected
    );

    button.classList.toggle(
  'button--primary',
  buttonIsSelected
);

button.classList.toggle(
  'button--secondary',
  !buttonIsSelected
);

    button.setAttribute(
      'aria-pressed',
      String(buttonIsSelected)
    );

    button.addEventListener('click', () => {
      gripState.installation = method;

      gripInstallationOptionsContainer
        .querySelectorAll(
          '[data-grip-installation-value]'
        )
        .forEach((installationButton) => {
          const isSelected =
            installationButton.dataset
              .gripInstallationValue === method;

          installationButton.classList.toggle(
  'button--primary',
  isSelected
);

installationButton.classList.toggle(
  'button--secondary',
  !isSelected
);

          installationButton.setAttribute(
            'aria-pressed',
            String(isSelected)
          );
        });
    });

    gripInstallationOptionsContainer.appendChild(
      button
    );
  });
}

function renderGripDependentOptions() {
  renderSelectedGrip();
  renderGripSizeOptions();
  renderGripInstallationOptions();
}

function getShaftManufacturers() {
  return [
    ...new Set(
      shafts
        .map((shaft) => String(shaft.manufacturer || '').trim())
        .filter(Boolean)
    )
  ];
}
function chooseDefaultFlex(flexes) {
  if (!flexes.length) return '';

  const preferredFlexes = [
    'regular',
    'stiff',
    'x-stiff',
    'extra stiff'
  ];

  for (const preferredFlex of preferredFlexes) {
    const match = flexes.find(
      (flex) =>
        String(flex || '').trim().toLowerCase() ===
        preferredFlex
    );

    if (match) return match;
  }

  return flexes[0];
}

function chooseDefaultLength(lengths) {
  if (!lengths.length) return '';

  const standardLength = lengths.find(
    (length) =>
      String(length || '').trim().toLowerCase() ===
      'standard'
  );

  return standardLength || lengths[0];
}
function renderSelectedShaft() {
    
  if (!shaftImageContainer) return;

  shaftImageContainer.innerHTML = '';

  const selectedShaft = shaftState.shaft;

  if (!selectedShaft?.image_url) {
    shaftImageContainer.hidden = true;
    return;
  }

  const image = document.createElement('img');

  image.src = selectedShaft.image_url;
  image.alt = selectedShaft.shaft_name || 'Selected shaft';
  image.loading = 'lazy';

  shaftImageContainer.appendChild(image);
  shaftImageContainer.hidden = false;
}
function renderFlexOptions() {
  if (!flexOptionsContainer) return;

  flexOptionsContainer.innerHTML = '';

  const flexes = Array.isArray(
    shaftState.shaft?.available_flexes
  )
    ? shaftState.shaft.available_flexes
    : [];

  if (!flexes.length) {
    shaftState.flex = null;
    flexOptionsContainer.hidden = true;
    return;
  }

  const selectedFlex =
    flexes.includes(shaftState.flex)
      ? shaftState.flex
      : chooseDefaultFlex(flexes);

  shaftState.flex = selectedFlex;
  flexOptionsContainer.hidden = false;

  flexes.forEach((flex) => {
    const label = document.createElement('label');
    label.className = 'gc-choice-card';

    const input = document.createElement('input');
    input.type = 'radio';
    input.name = 'gc-flex';
    input.value = flex;
    input.dataset.flexValue = flex;
    input.checked = flex === selectedFlex;

    const content = document.createElement('span');
    content.className = 'gc-choice-card__content';
    content.textContent = flex;

    label.appendChild(input);
    label.appendChild(content);

    input.addEventListener('change', () => {
      if (!input.checked) return;

      shaftState.flex = flex;

      flexOptionsContainer
        .querySelectorAll('input[type="radio"]')
        .forEach((radio) => {
          radio.checked = radio.dataset.flexValue === flex;
        });
    });

    flexOptionsContainer.appendChild(label);
  });
}

function renderLengthOptions() {
  if (!shaftLengthSelect) return;

  shaftLengthSelect.innerHTML = '';

  const lengths = Array.isArray(
    shaftState.shaft?.available_shaft_lengths
  )
    ? shaftState.shaft.available_shaft_lengths
    : [];

  if (!lengths.length) {
    shaftState.length = null;
    shaftLengthSelect.hidden = true;
    return;
  }

  const selectedLength =
    lengths.includes(shaftState.length)
      ? shaftState.length
      : chooseDefaultLength(lengths);

  shaftState.length = selectedLength;
  shaftLengthSelect.hidden = false;

  lengths.forEach((length) => {
    const option = document.createElement('option');

    option.value = length;
    option.textContent = length;

    shaftLengthSelect.appendChild(option);
  });

  shaftLengthSelect.value = selectedLength;
}

function renderShaftDependentOptions() {
  renderSelectedShaft();
  renderFlexOptions();
  renderLengthOptions();
}

function populateManufacturerOptions() {
  if (!shaftManufacturerSelect) return;

  const manufacturers = getShaftManufacturers();

  shaftManufacturerSelect.innerHTML = '';

  manufacturers.forEach((manufacturer) => {
    const option = document.createElement('option');

    option.value = manufacturer;
    option.textContent = manufacturer;

    shaftManufacturerSelect.appendChild(option);
  });

const configuredDefaultShaft = shafts.find(
  (shaft) =>
    String(shaft.shaft_name || '').trim().toLowerCase() ===
    defaultShaftName.trim().toLowerCase()
);

const manufacturerFromDefaultShaft =
  configuredDefaultShaft?.manufacturer || '';

const startingManufacturer =
  manufacturerFromDefaultShaft ||
  manufacturers.find(
    (manufacturer) =>
      manufacturer.toLowerCase() ===
      defaultShaftManufacturer.trim().toLowerCase()
  ) ||
  manufacturers[0] ||
  '';

  shaftManufacturerSelect.value = startingManufacturer;
  shaftState.manufacturer = startingManufacturer;

populateShaftOptions(
  startingManufacturer,
  defaultShaftName
);
}

populateGripBrandOptions();

if (gripBrandSelect && gripSelect) {
  gripBrandSelect.addEventListener(
    'change',
    () => {
      const selectedBrand =
        gripBrandSelect.value;

      gripState.brand = selectedBrand;

      populateGripOptions(
        selectedBrand
      );
    }
  );

  gripSelect.addEventListener(
    'change',
    () => {
      const selectedGripName =
        gripSelect.value;

      gripState.grip =
        grips.find(
          (grip) =>
            String(grip.brand || '').trim() ===
              String(gripState.brand || '').trim() &&
            String(grip.grip_name || '').trim() ===
              String(selectedGripName || '').trim()
        ) || null;

      gripState.size = null;
      gripState.installation = null;

      renderGripDependentOptions();
    }
  );
}

if (shaftManufacturerSelect && shaftSelect) {
  populateManufacturerOptions();

  shaftManufacturerSelect.addEventListener('change', () => {
    const selectedManufacturer =
      shaftManufacturerSelect.value;

    shaftState.manufacturer = selectedManufacturer;

    populateShaftOptions(selectedManufacturer);
  });
  
  renderShaftDependentOptions();

  shaftSelect.addEventListener('change', () => {
    const selectedShaftName = shaftSelect.value;

    shaftState.shaft =
      shafts.find(
        (shaft) =>
          String(shaft.manufacturer || '').trim() ===
            shaftState.manufacturer &&
          String(shaft.shaft_name || '').trim() ===
            selectedShaftName
      ) || null;

    shaftState.flex = null;
    shaftState.length = null;

    renderShaftDependentOptions();
  });
}
if (shaftLengthSelect) {
  shaftLengthSelect.addEventListener('change', () => {
    shaftState.length = shaftLengthSelect.value;
  });
}

if (continueToGripButton) {
  continueToGripButton.addEventListener('click', () => {
    openStep(4);

    const gripStep = configurator.querySelector(
      '[data-configurator-step="4"]'
    );

    if (gripStep) {
      window.setTimeout(() => {
        gripStep.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 150);
    }
  });
}
function getShaftUpcharge(shaft) {
  const value = shaft?.upcharge;

  if (typeof value === 'number') {
    return value / 100;
  }

  if (typeof value === 'string') {
    return (Number(value) || 0) / 100;
  }

  if (value && typeof value === 'object') {
    return Number(value.amount || 0) / 100;
  }

  return 0;
}

function getGripUpcharge(grip) {
  const value = grip?.upcharge;

  if (typeof value === 'number') {
    return value / 100;
  }

  if (typeof value === 'string') {
    return (Number(value) || 0) / 100;
  }

  if (value && typeof value === 'object') {
    return Number(
      value.amount ??
      value.value ??
      0
    ) / 100;
  }

  return 0;
}

function populateShaftOptions(
  manufacturer,
  preferredShaftName = ''
) {
  if (!shaftSelect) return;

  const matchingShafts = shafts
    .filter(
      (shaft) =>
        String(shaft.manufacturer || '').trim() === manufacturer
    )
    .sort(
      (a, b) =>
        Number(a.sort_order || 9999) -
        Number(b.sort_order || 9999)
    );

  shaftSelect.innerHTML = '';

 matchingShafts.forEach((shaft) => {
  const shaftName = String(shaft.shaft_name || '').trim();
  const upcharge = getShaftUpcharge(shaft);

  const option = document.createElement('option');

  option.value = shaftName;

if (upcharge > 0) {
  const formattedUpcharge = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
  }).format(upcharge);

  option.textContent =
    `${shaftName} (+${formattedUpcharge} per club)`;
} else {
  option.textContent = shaftName;
}

  shaftSelect.appendChild(option);
});

  const preferredExists = matchingShafts.some(
    (shaft) =>
      String(shaft.shaft_name || '').trim().toLowerCase() ===
      preferredShaftName.trim().toLowerCase()
  );

  const startingShaftName = preferredExists
    ? matchingShafts.find(
        (shaft) =>
          String(shaft.shaft_name || '').trim().toLowerCase() ===
          preferredShaftName.trim().toLowerCase()
      )?.shaft_name
    : matchingShafts[0]?.shaft_name || '';

  shaftSelect.value = String(startingShaftName || '').trim();

  shaftState.shaft =
    matchingShafts.find(
      (shaft) =>
        String(shaft.shaft_name || '').trim() ===
        shaftSelect.value
    ) || null;

  shaftState.flex = null;
  shaftState.length = null;

  renderShaftDependentOptions();
}
console.log('Shafts loaded:', shafts);

    const steps = Array.from(
      configurator.querySelectorAll('[data-configurator-step]')
    );

    const progressItems = Array.from(
      configurator.querySelectorAll('[data-progress-item]')
    );

function updateProgressUI(currentStep) {
  progressItems.forEach((item) => {
    const step = Number(item.dataset.progressItem);

    item.classList.remove(
      'gc-progress__item--active',
      'gc-progress__item--complete'
    );

    if (step < currentStep) {
      item.classList.add('gc-progress__item--complete');
    } else if (step === currentStep) {
      item.classList.add('gc-progress__item--active');
    }
  });
}

    const handInputs = Array.from(
      configurator.querySelectorAll(
        'input[type="radio"][name^="gc-hand-"]'
      )
    );

let availableHands = [];

try {
  availableHands = JSON.parse(
    configurator.dataset.availableHands || '[]'
  );
} catch (error) {
  availableHands = [];
}

const defaultHand =
  configurator.dataset.defaultHand || '';

function normalizeHand(value) {
  return String(value || '').trim().toLowerCase();
}

function applyProductHandSettings() {
  if (!handInputs.length) return;

  const normalizedAvailableHands =
    availableHands.map(normalizeHand);

  const hasConfiguredHands =
    normalizedAvailableHands.length > 0;

  handInputs.forEach((input) => {
    const isAvailable =
      !hasConfiguredHands ||
      normalizedAvailableHands.includes(
        normalizeHand(input.value)
      );

    input.disabled = !isAvailable;

const label = input.closest('label');

if (label) {
  label.hidden = !isAvailable;

  label.classList.toggle(
    'is-disabled',
    !isAvailable
  );
}
  });

  const requestedDefault = handInputs.find(
    (input) =>
      !input.disabled &&
      normalizeHand(input.value) ===
        normalizeHand(defaultHand)
  );

  const firstAvailable = handInputs.find(
    (input) => !input.disabled
  );

  const startingHand =
    requestedDefault || firstAvailable;

  if (!startingHand) return;

  handInputs.forEach((input) => {
    input.checked = input === startingHand;
  });

  startingHand.dispatchEvent(
    new Event('change', { bubbles: true })
  );
}
    const ironInputs = Array.from(
      configurator.querySelectorAll('.gc-iron-input')
    );

    const availableIronOrder = ironInputs.map(
      (input) => input.value
    );

    const summaryHand = configurator.querySelector(
      '[data-summary-hand]'
    );

    const summaryIrons = configurator.querySelector(
      '[data-summary-irons]'
    );

    const summaryCount = configurator.querySelector(
      '[data-summary-count]'
    );

    const summaryShaftManufacturer =
  configurator.querySelector(
    '[data-summary-shaft-manufacturer]'
  );

const summaryShaftModel =
  configurator.querySelector(
    '[data-summary-shaft-model]'
  );

const summaryShaftFlex =
  configurator.querySelector(
    '[data-summary-shaft-flex]'
  );

const summaryShaftLength =
  configurator.querySelector(
    '[data-summary-shaft-length]'
  );

const summaryGripBrand =
  configurator.querySelector(
    '[data-summary-grip-brand]'
  );

const summaryGripModel =
  configurator.querySelector(
    '[data-summary-grip-model]'
  );

const summaryGripSize =
  configurator.querySelector(
    '[data-summary-grip-size]'
  );

const summaryGripInstallation =
  configurator.querySelector(
    '[data-summary-grip-installation]'
  );

const summaryLoft =
  configurator.querySelector(
    '[data-summary-loft]'
  );

const summaryLie =
  configurator.querySelector(
    '[data-summary-lie]'
  );

    const stepSummaryHand = configurator.querySelector(
      '[data-step-summary-hand]'
    );

    const stepSummaryIrons = configurator.querySelector(
      '[data-step-summary-irons]'
    );

    const priceCalculation = configurator.querySelector(
      '[data-price-calculation]'
    );

    const ironSubtotal = configurator.querySelector(
      '[data-iron-subtotal]'
    );

    const shaftUpchargeRow =
  configurator.querySelector(
    '[data-shaft-upcharge-row]'
  );

const shaftPriceCalculation =
  configurator.querySelector(
    '[data-shaft-price-calculation]'
  );

const shaftUpchargeTotal =
  configurator.querySelector(
    '[data-shaft-upcharge-total]'
  );

const gripUpchargeRow =
  configurator.querySelector(
    '[data-grip-upcharge-row]'
  );

const gripPriceCalculation =
  configurator.querySelector(
    '[data-grip-price-calculation]'
  );

const gripUpchargeTotal =
  configurator.querySelector(
    '[data-grip-upcharge-total]'
  );

    const totalPrice = configurator.querySelector(
      '[data-total-price]'
    );

    const customOrderDiscount =
  configurator.querySelector(
    '[data-custom-order-discount]'
  );

const discountedTotalPrice =
  configurator.querySelector(
    '[data-discounted-total-price]'
  );

    const selectionStatus = configurator.querySelector(
      '[data-selection-status]'
    );

    const buildSummary = configurator.querySelector(
      '[data-build-summary]'
    );

    const addToCartButton = configurator.querySelector(
      '[data-add-to-cart]'
    );

const productForm =
  configurator.querySelector(
    '.gc-product-form'
  );

const propertyHand =
  configurator.querySelector(
    '[data-property-hand]'
  );

const propertyModel =
  configurator.querySelector(
    '[data-property-model]'
  );

const propertyIrons =
  configurator.querySelector(
    '[data-property-irons]'
  );

const propertyClubCount =
  configurator.querySelector(
    '[data-property-club-count]'
  );

const propertyShaftManufacturer =
  configurator.querySelector(
    '[data-property-shaft-manufacturer]'
  );

const propertyShaftModel =
  configurator.querySelector(
    '[data-property-shaft-model]'
  );

const propertyShaftFlex =
  configurator.querySelector(
    '[data-property-shaft-flex]'
  );

const propertyShaftLength =
  configurator.querySelector(
    '[data-property-shaft-length]'
  );

const propertyGripBrand =
  configurator.querySelector(
    '[data-property-grip-brand]'
  );

const propertyGripModel =
  configurator.querySelector(
    '[data-property-grip-model]'
  );

const propertyGripSize =
  configurator.querySelector(
    '[data-property-grip-size]'
  );

const propertyGripInstallation =
  configurator.querySelector(
    '[data-property-grip-installation]'
  );

const propertyLoft =
  configurator.querySelector(
    '[data-property-loft]'
  );

const propertyLie =
  configurator.querySelector(
    '[data-property-lie]'
  );

const propertyShaftUpcharge =
  configurator.querySelector(
    '[data-property-shaft-upcharge]'
  );

const propertyGripUpcharge =
  configurator.querySelector(
    '[data-property-grip-upcharge]'
  );

const propertyCustomTotal =
  configurator.querySelector(
    '[data-property-custom-total]'
  );

const policyCheckbox =
  configurator.querySelector(
    '[data-policy-checkbox]'
  );


const validationMessage =
    configurator.querySelector('[data-validation-message]');

const propertyPolicyAccepted =
  configurator.querySelector(
    '[data-property-policy-accepted]'
  );
  
    const moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100);
    }

    function getStep(stepNumber) {
      return configurator.querySelector(
        `[data-configurator-step="${stepNumber}"]`
      );
    }

    function openStep(stepNumber, shouldScroll = false) {
  const targetStep = getStep(stepNumber);
  const currentStepNumber = Number(stepNumber);

  if (!targetStep) return;

  steps.forEach((step) => {
    const stepNumberValue = Number(
      step.dataset.configuratorStep
    );

    const panel = step.querySelector(
      '[data-step-panel]'
    );

    const toggle = step.querySelector(
      '[data-step-toggle]'
    );

    const shouldOpen =
      stepNumberValue === currentStepNumber;

    step.classList.toggle(
      'is-open',
      shouldOpen
    );

    if (panel) {
      panel.hidden = !shouldOpen;
    }

    if (toggle) {
      toggle.setAttribute(
        'aria-expanded',
        shouldOpen ? 'true' : 'false'
      );
    }
  });

  progressItems.forEach((item) => {
    const itemNumber = Number(
      item.dataset.progressItem
    );

    item.classList.toggle(
      'gc-progress__item--active',
      itemNumber === currentStepNumber
    );

  });

  if (shouldScroll) {
  targetStep.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}

updateProgressUI(stepNumber);
}

function completeStep(stepNumber) {
  const step = getStep(stepNumber);

  const progressItem = progressItems.find(
    (item) =>
      Number(item.dataset.progressItem) === Number(stepNumber)
  );

  if (!step) return;

  step.dataset.stepConfirmed = 'true';
  step.classList.add('is-complete');

if (progressItem) {
  progressItem.classList.add('gc-progress__item--complete');
}

updateStepLockStates();
validateBuild();
}

    function getSelectedIrons() {
  return ironInputs
    .filter((input) => input.checked)
    .map((input) => input.value)
    .sort((firstIron, secondIron) => {
      return (
        availableIronOrder.indexOf(firstIron) -
        availableIronOrder.indexOf(secondIron)
      );
    });
}

    function getMissingIrons(selectedIrons) {
      if (selectedIrons.length < 2) {
        return [];
      }

      const selectedIndexes = selectedIrons
        .map((iron) => availableIronOrder.indexOf(iron))
        .filter((index) => index >= 0);

      if (selectedIndexes.length < 2) {
        return [];
      }

      const firstIndex = Math.min(...selectedIndexes);
      const lastIndex = Math.max(...selectedIndexes);

      return availableIronOrder
        .slice(firstIndex, lastIndex + 1)
        .filter((iron) => !selectedIrons.includes(iron));
    }

    function formatIronList(irons) {
      if (irons.length === 0) {
        return 'None selected';
      }

      return irons.join(', ');
    }

    function formatClubName(iron) {
      if (/^[3-9]$/.test(iron)) {
        return `${iron} Iron`;
      }

      return iron;
    }

    function formatMissingIronNames(irons) {
      const formattedIrons = irons.map(formatClubName);

      if (formattedIrons.length === 1) {
        return formattedIrons[0];
      }

      if (formattedIrons.length === 2) {
        return `${formattedIrons[0]} and ${formattedIrons[1]}`;
      }

      const finalIron =
        formattedIrons[formattedIrons.length - 1];

      return `${formattedIrons
        .slice(0, -1)
        .join(', ')}, and ${finalIron}`;
    }

    function updateStepCompletion() {
  const steps = configurator.querySelectorAll(
    '[data-configurator-step]'
  );

  steps.forEach((step) => {
    const isConfirmed =
      step.dataset.stepConfirmed === 'true';

    step.classList.toggle(
      'is-complete',
      isConfirmed
    );
  });
}

    function updateSelectionMessage(selectedIrons) {
      if (!selectionStatus) {
        return;
      }

      selectionStatus.classList.remove(
        'gc-selection-status--success',
        'gc-selection-status--warning',
        'gc-selection-status--empty'
      );

      if (selectedIrons.length === 0) {
        selectionStatus.classList.add(
          'gc-selection-status--empty'
        );

        selectionStatus.innerHTML = `
          <strong>Select at least one club.</strong>
          You may order a full set, partial set, or individual club.
        `;

        return;
      }

      if (selectedIrons.length === 1) {
        selectionStatus.classList.add(
          'gc-selection-status--success'
        );

        selectionStatus.innerHTML = `
          <strong>Single club order.</strong>
          This is ideal for a replacement or individually customized club.
        `;

        return;
      }

      const missingIrons = getMissingIrons(selectedIrons);

      if (missingIrons.length === 0) {
        selectionStatus.classList.add(
          'gc-selection-status--success'
        );

        selectionStatus.innerHTML = `
          <strong>Complete consecutive selection.</strong>
          Your selected clubs contain no gaps.
        `;

        return;
      }

      const missingNames =
        formatMissingIronNames(missingIrons);

      selectionStatus.classList.add(
        'gc-selection-status--warning'
      );

      if (missingIrons.length === 1) {
        selectionStatus.innerHTML = `
          <strong>Please review your selection.</strong>
          You have skipped the ${missingNames}.
          This is perfectly acceptable for replacement clubs
          or an intentionally customized set.
        `;
      } else {
        selectionStatus.innerHTML = `
          <strong>Please review your selection.</strong>
          You have skipped ${missingNames}.
          This is perfectly acceptable for replacement clubs
          or an intentionally customized set.
        `;
      }
    }

    function isIronSelectionValid() {
  const selectedIrons = getSelectedIrons();

  return selectedIrons.length > 0;
}

    function updateHand() {
      const selectedHand = configurator.querySelector(
        'input[type="radio"][name^="gc-hand-"]:checked'
      );

      const handValue = selectedHand
        ? selectedHand.value
        : 'Not selected';

      if (summaryHand) {
        summaryHand.textContent = handValue;
      }

      if (stepSummaryHand) {
        stepSummaryHand.textContent = handValue;
      }

    }

function updateBuildSummary() {
  const selectedShaft = shaftState.shaft;
  const selectedGrip = gripState.grip;

  if (summaryShaftManufacturer) {
    summaryShaftManufacturer.textContent =
      shaftState.manufacturer ||
      selectedShaft?.manufacturer ||
      'Not selected';
  }

  if (summaryShaftModel) {
    summaryShaftModel.textContent =
      selectedShaft?.shaft_name ||
      'Not selected';
  }

  if (summaryShaftFlex) {
    summaryShaftFlex.textContent =
      shaftState.flex ||
      'Not selected';
  }

  if (summaryShaftLength) {
    summaryShaftLength.textContent =
      shaftState.length ||
      'Standard';
  }

  if (summaryGripBrand) {
    summaryGripBrand.textContent =
      gripState.brand ||
      selectedGrip?.brand ||
      'Not selected';
  }

  if (summaryGripModel) {
    summaryGripModel.textContent =
      selectedGrip?.grip_name ||
      'Not selected';
  }

  if (summaryGripSize) {
    summaryGripSize.textContent =
      gripState.size ||
      'Standard';
  }

  if (summaryGripInstallation) {
    summaryGripInstallation.textContent =
      gripState.installation ||
      'Standard';
  }

  const loftSelect = configurator.querySelector(
    'select[data-loft-select], select[name*="loft" i], select[id*="loft" i]'
  );

  const lieSelect = configurator.querySelector(
    'select[data-lie-select], select[name*="lie" i], select[id*="lie" i]'
  );

  if (summaryLoft) {
    summaryLoft.textContent =
      loftSelect?.selectedOptions?.[0]?.textContent?.trim() ||
      loftSelect?.value ||
      'Standard';
  }

  if (summaryLie) {
    summaryLie.textContent =
      lieSelect?.selectedOptions?.[0]?.textContent?.trim() ||
      lieSelect?.value ||
      'Standard';
  }

  updateBuildPricing();
}

function updateBuildPricing() {
  const selectedIrons = getSelectedIrons();
  const ironCount = selectedIrons.length;

  const baseSubtotalCents =
    ironCount * pricePerIron;

  const shaftUpchargePerClub =
    getShaftUpcharge(shaftState.shaft);

  const gripUpchargePerClub =
    getGripUpcharge(gripState.grip);

  const shaftUpchargeCents = Math.round(
    ironCount * shaftUpchargePerClub * 100
  );

  const gripUpchargeCents = Math.round(
    ironCount * gripUpchargePerClub * 100
  );

  const finalTotalCents =
    baseSubtotalCents +
    shaftUpchargeCents +
    gripUpchargeCents;

    const discountRate = 0.10;

const discountCents = Math.round(
  finalTotalCents * discountRate
);

const discountedFinalTotalCents =
  finalTotalCents - discountCents;

  if (shaftUpchargeRow) {
    shaftUpchargeRow.hidden =
      shaftUpchargePerClub <= 0;
  }

  if (shaftPriceCalculation) {
    shaftPriceCalculation.textContent =
      `Shaft upcharge: ${ironCount} clubs × ` +
      formatMoney(
        Math.round(shaftUpchargePerClub * 100)
      );
  }

  if (shaftUpchargeTotal) {
    shaftUpchargeTotal.textContent =
      formatMoney(shaftUpchargeCents);
  }

  if (gripUpchargeRow) {
    gripUpchargeRow.hidden =
      gripUpchargePerClub <= 0;
  }

  if (gripPriceCalculation) {
    gripPriceCalculation.textContent =
      `Grip upcharge: ${ironCount} clubs × ` +
      formatMoney(
        Math.round(gripUpchargePerClub * 100)
      );
  }

  if (gripUpchargeTotal) {
    gripUpchargeTotal.textContent =
      formatMoney(gripUpchargeCents);
  }

  if (totalPrice) {
    totalPrice.textContent =
      formatMoney(finalTotalCents);
  }

if (customOrderDiscount) {
  customOrderDiscount.textContent =
    `-${formatMoney(discountCents)}`;
}

if (discountedTotalPrice) {
  discountedTotalPrice.textContent =
    formatMoney(
      discountedFinalTotalCents
    );
}

}

function updateCartProperties() {
  const selectedHand = configurator.querySelector(
    'input[type="radio"][name^="gc-hand-"]:checked'
  );

  const selectedIrons = getSelectedIrons();
  const ironCount = selectedIrons.length;

  const selectedShaft = shaftState.shaft;
  const selectedGrip = gripState.grip;

  const loftSelect = configurator.querySelector(
    'select[data-loft-select]'
  );

  const lieSelect = configurator.querySelector(
    'select[data-lie-select]'
  );

  const shaftUpchargePerClub =
    getShaftUpcharge(selectedShaft);

  const gripUpchargePerClub =
    getGripUpcharge(selectedGrip);

  const baseSubtotalCents =
    ironCount * pricePerIron;

  const shaftUpchargeCents = Math.round(
    ironCount *
    shaftUpchargePerClub *
    100
  );

  const gripUpchargeCents = Math.round(
    ironCount *
    gripUpchargePerClub *
    100
  );

  const finalTotalCents =
    baseSubtotalCents +
    shaftUpchargeCents +
    gripUpchargeCents;

  if (propertyHand) {
    propertyHand.value =
      selectedHand?.value ||
      'Not selected';
  }

  if (propertyIrons) {
    propertyIrons.value =
      formatIronList(selectedIrons);
  }

  if (propertyClubCount) {
    propertyClubCount.value =
      String(ironCount);
  }

  if (propertyShaftManufacturer) {
    propertyShaftManufacturer.value =
      shaftState.manufacturer ||
      selectedShaft?.manufacturer ||
      'Not selected';
  }

  if (propertyShaftModel) {
    propertyShaftModel.value =
      selectedShaft?.shaft_name ||
      'Not selected';
  }

  if (propertyShaftFlex) {
    propertyShaftFlex.value =
      shaftState.flex ||
      'Not selected';
  }

  if (propertyShaftLength) {
    propertyShaftLength.value =
      shaftState.length ||
      'Standard';
  }

  if (propertyGripBrand) {
    propertyGripBrand.value =
      gripState.brand ||
      selectedGrip?.brand ||
      'Not selected';
  }

  if (propertyGripModel) {
    propertyGripModel.value =
      selectedGrip?.grip_name ||
      'Not selected';
  }

  if (propertyGripSize) {
    propertyGripSize.value =
      gripState.size ||
      'Standard';
  }

  if (propertyGripInstallation) {
    propertyGripInstallation.value =
      gripState.installation ||
      'Standard';
  }

  if (propertyLoft) {
    propertyLoft.value =
      loftSelect?.value ||
      'Standard';
  }

  if (propertyLie) {
    propertyLie.value =
      lieSelect?.value ||
      'Standard';
  }

  if (propertyShaftUpcharge) {
    propertyShaftUpcharge.value =
      shaftUpchargePerClub > 0
        ? `${ironCount} clubs × ${formatMoney(
            Math.round(
              shaftUpchargePerClub * 100
            )
          )} = ${formatMoney(
            shaftUpchargeCents
          )}`
        : '$0.00';
  }

  if (propertyGripUpcharge) {
    propertyGripUpcharge.value =
      gripUpchargePerClub > 0
        ? `${ironCount} clubs × ${formatMoney(
            Math.round(
              gripUpchargePerClub * 100
            )
          )} = ${formatMoney(
            gripUpchargeCents
          )}`
        : '$0.00';
  }

  if (propertyCustomTotal) {
    propertyCustomTotal.value =
      formatMoney(finalTotalCents);
  }
}

    function updateIrons() {
      const selectedIrons = getSelectedIrons();
      const ironCount = selectedIrons.length;
      const subtotal = ironCount * pricePerIron;
      const ironList = formatIronList(selectedIrons);

      if (summaryIrons) {
        summaryIrons.textContent = ironList;
      }

      if (stepSummaryIrons) {
        stepSummaryIrons.textContent = ironList;
      }

      if (summaryCount) {
        summaryCount.textContent = String(ironCount);
      }

      if (priceCalculation) {
        priceCalculation.textContent =
          ironCount === 1
            ? `1 club × ${formatMoney(pricePerIron)}`
            : `${ironCount} clubs × ${formatMoney(pricePerIron)}`;
      }

      if (ironSubtotal) {
        ironSubtotal.textContent =
          formatMoney(subtotal);
      }

      updateBuildPricing();

      updatePolicyAgreement();

      updateSelectionMessage(selectedIrons);
    }

    function isStepUnlocked(stepNumber) {
  if (stepNumber === 1) return true;

  const previousStep = getStep(stepNumber - 1);

  return Boolean(
    previousStep &&
    previousStep.dataset.stepConfirmed === 'true'
  );
}

function updateStepLockStates() {
  steps.forEach((step) => {
    const stepNumber = Number(step.dataset.configuratorStep);
    const toggle = step.querySelector('[data-step-toggle]');
    const unlocked = isStepUnlocked(stepNumber);

    step.classList.toggle('is-locked', !unlocked);

    if (unlocked) {
  const lockMessage = step.querySelector('.gc-step-lock-message');

  if (lockMessage) {
    lockMessage.remove();
  }
}

    if (toggle) {
      toggle.setAttribute('aria-disabled', String(!unlocked));
      toggle.tabIndex = unlocked ? 0 : -1;
    }
  });
}

configurator
  .querySelectorAll('[data-step-toggle]')
  .forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const step = toggle.closest(
        '[data-configurator-step]'
      );

      if (!step) return;

      const stepNumber =
        Number(step.dataset.configuratorStep);

      // Do not allow future steps to open until
      // the immediately previous step is confirmed.
      if (!isStepUnlocked(stepNumber)) {
  const previousStepNumber = stepNumber - 1;

  const stepNames = {
    1: 'Choose Hand',
    2: 'Select Irons',
    3: 'Configure Shaft',
    4: 'Configure Grip',
    5: 'Final Adjustments'
  };

  const message =
    step.querySelector('.gc-step-lock-message') ||
    document.createElement('div');

  message.className = 'gc-step-lock-message';
  message.textContent =
    `Complete Step ${previousStepNumber}: ${stepNames[previousStepNumber]} to continue.`;

  if (!message.parentNode) {
    step.appendChild(message);
  }

  return;
}

      // Allow an already-open step to collapse.
      if (step.classList.contains('is-open')) {
        const panel = step.querySelector(
          '[data-step-panel]'
        );

        step.classList.remove('is-open');

        if (panel) {
          panel.hidden = true;
        }

        toggle.setAttribute(
          'aria-expanded',
          'false'
        );

        return;
      }

      openStep(stepNumber);
    });
  });

  configurator
  .querySelectorAll('[data-next-step]')
  .forEach((button) => {
    button.addEventListener('click', () => {
      const currentStep = button.closest(
        '[data-configurator-step]'
      );

      const currentStepNumber = Number(
        currentStep?.dataset.configuratorStep
      );

      const nextStep = Number(
        button.dataset.nextStep
      );

// Step 2 must have at least one iron selected
if (currentStepNumber === 2 && !isIronSelectionValid()) {
  updateSelectionMessage(getSelectedIrons());
  return;
}

if (currentStepNumber) {
  completeStep(currentStepNumber);
}

openStep(nextStep, true);
});
});

    const reviewButton = configurator.querySelector(
      '[data-review-build]'
    );

    if (reviewButton) {
      reviewButton.addEventListener('click', () => {
        completeStep(5);
        steps.forEach((step) => {
          const panel = step.querySelector(
            '[data-step-panel]'
          );

          const toggle = step.querySelector(
            '[data-step-toggle]'
          );

          step.classList.remove('is-open');

          if (panel) {
            panel.hidden = true;
          }

          if (toggle) {
            toggle.setAttribute(
              'aria-expanded',
              'false'
            );
          }
        });

        if (buildSummary) {
          buildSummary.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    }

    handInputs.forEach((input) => {
      input.addEventListener(
        'change',
        updateHand
      );
    });

    ironInputs.forEach((input) => {
      input.addEventListener(
        'change',
        updateIrons
      );
    });

configurator.addEventListener('change', () => {
  updateBuildSummary();
  updateCartProperties();
  validateBuild();
});

configurator.addEventListener('click', () => {
  window.setTimeout(() => {
    updateBuildSummary();
    updateCartProperties();
    validateBuild();
  }, 0);
});

configurator.addEventListener('click', (event) => {
  const validationStepButton = event.target.closest(
    '[data-validation-step]'
  );

  if (!validationStepButton) return;

  const stepNumber = Number(
    validationStepButton.dataset.validationStep
  );

  if (!stepNumber) return;

  openStep(stepNumber, true);
});

function validateBuild() {
  const stepNames = {
    1: 'Choose Hand',
    2: 'Select Irons',
    3: 'Configure Shaft',
    4: 'Configure Grip',
    5: 'Final Adjustments'
  };

  const requiredSteps = [1, 2, 3, 4, 5];

  const incompleteSteps = requiredSteps.filter((stepNumber) => {
    const progressItem = progressItems.find(
      (item) =>
        Number(item.dataset.progressItem) === Number(stepNumber)
    );

    return !(
      progressItem &&
      progressItem.classList.contains('gc-progress__item--complete')
    );
  });

  const allStepsComplete = incompleteSteps.length === 0;
  const policyAccepted = Boolean(policyCheckbox?.checked);

  const isValid = allStepsComplete && policyAccepted;

  if (addToCartButton) {
    addToCartButton.disabled = !isValid;

    addToCartButton.setAttribute(
      'aria-disabled',
      String(!isValid)
    );

    addToCartButton.classList.toggle(
      'gc-button--disabled',
      !isValid
    );
  }

  if (validationMessage) {
  const stepStatusHtml = requiredSteps
    .map((stepNumber) => {
      const progressItem = progressItems.find(
        (item) =>
          Number(item.dataset.progressItem) === Number(stepNumber)
      );

      const isComplete = Boolean(
        progressItem &&
        progressItem.classList.contains('gc-progress__item--complete')
      );

      const statusIcon = isComplete ? '✓' : '○';
      const statusClass = isComplete ? 'is-complete' : 'is-incomplete';

      return `
        <button
          type="button"
          class="gc-validation-step ${statusClass}"
          data-validation-step="${stepNumber}"
        >
          <span class="gc-validation-step__icon">${statusIcon}</span>
          <span>Step ${stepNumber}: ${stepNames[stepNumber]}</span>
        </button>
      `;
    })
    .join('');

  const policyStatus = policyAccepted ? '✓' : '○';
  const policyClass = policyAccepted ? 'is-complete' : 'is-incomplete';

  validationMessage.innerHTML = `
    <strong>Complete your custom build:</strong>

    <div class="gc-validation-steps">
      ${stepStatusHtml}

      <div class="gc-validation-step ${policyClass}">
        <span class="gc-validation-step__icon">${policyStatus}</span>
        <span>Accept Custom Order & Cancellation Policy</span>
      </div>
    </div>
  `;

  if (isValid) {
    validationMessage.innerHTML = '';
  }
}

  return isValid;
}

function getFirstIncompleteStep() {
  const requiredSteps = [1, 2, 3, 4, 5];

  return requiredSteps.find((stepNumber) => {
    const progressItem = progressItems.find(
      (item) =>
        Number(item.dataset.progressItem) === Number(stepNumber)
    );

    return !(
      progressItem &&
      progressItem.classList.contains('gc-progress__item--complete')
    );
  });
}

function updatePolicyAgreement() {
  const isAccepted = Boolean(policyCheckbox?.checked);

  if (propertyPolicyAccepted) {
    propertyPolicyAccepted.value =
      isAccepted ? 'Yes' : 'No';
  }

  const isValid = validateBuild();

  if (isAccepted && !isValid) {
    const firstIncompleteStep = getFirstIncompleteStep();

    if (firstIncompleteStep) {
      openStep(firstIncompleteStep, true);
    }
  }
}

if (policyCheckbox) {
  policyCheckbox.addEventListener(
    'change',
    updatePolicyAgreement
  );
}

if (productForm) {
  productForm.addEventListener('submit', async (event) => {
    event.preventDefault();

    updateBuildSummary();
    updateBuildPricing();
    updateCartProperties();
    updatePolicyAgreement();

    if (!policyCheckbox?.checked) {
      policyCheckbox?.focus();
      policyCheckbox?.reportValidity();
      return;
    }

    if (!pricingProducts) {
      console.error('Pricing products are not available.');
      alert('Unable to load custom-order pricing. Please refresh and try again.');
      return;
    }

    const selectedIrons = getSelectedIrons();
    const clubCount = selectedIrons.length;

    if (!clubCount) {
      alert('Please select at least one iron.');
      return;
    }

    function findVariantByPrice(group, priceCents) {
      if (!group?.variants?.length) return null;

      return group.variants.find(
        (variant) => Number(variant.price) === Number(priceCents)
      );
    }

const shaftUpchargePerClub =
  getShaftUpcharge(shaftState.shaft);

const gripUpchargePerClub =
  getGripUpcharge(gripState.grip);

const shaftUpchargeCents =
  Math.round(Number(shaftUpchargePerClub || 0) * 100);

const gripUpchargeCents =
  Math.round(Number(gripUpchargePerClub || 0) * 100);
    
    /*
      Iron unit should be the $285 helper variant.
      pricePerIron is already stored in dollars in your configurator.
    */
    const ironPriceCents =
      Math.round(Number(pricePerIron || 0));

console.log("Looking for iron price:", ironPriceCents);

console.log(
  "Available iron variants:",
  pricingProducts.iron.variants
);

    const ironVariant = findVariantByPrice(
      pricingProducts.iron,
      ironPriceCents
    );

    const shaftVariant = findVariantByPrice(
      pricingProducts.shaft,
      shaftUpchargeCents
    );

    console.log(
  'Looking for shaft price:',
  shaftUpchargeCents
);

console.log(
  'Available shaft variants:',
  pricingProducts.shaft.variants
);

    const gripVariant = findVariantByPrice(
      pricingProducts.grip,
      gripUpchargeCents
    );

    if (!ironVariant) {
      console.error(
        'No Custom Iron Unit variant found for:',
        ironPriceCents
      );

      alert(
        'The Custom Iron Unit pricing variant could not be found.'
      );

      return;
    }

    if (shaftUpchargeCents > 0 && !shaftVariant) {
      console.error(
        'No shaft pricing variant found for:',
        shaftUpchargeCents
      );

      alert(
        `The $${(shaftUpchargeCents / 100).toFixed(
          2
        )} shaft upgrade pricing variant could not be found.`
      );

      return;
    }

    if (gripUpchargeCents > 0 && !gripVariant) {
      console.error(
        'No grip pricing variant found for:',
        gripUpchargeCents
      );

      alert(
        `The $${(gripUpchargeCents / 100).toFixed(
          2
        )} grip upgrade pricing variant could not be found.`
      );

      return;
    }

    /*
      Read your existing Shopify product-form properties.
      This lets us reuse everything you already built:
      Hand, Irons, Shaft, Grip, Loft, Lie, etc.
    */
    const formData = new FormData(productForm);
    const buildProperties = {};

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);

      if (!match) continue;
      if (value === '' || value === null) continue;

      buildProperties[match[1]] = value;
    }

    /*
      Internal group ID ties the helper lines together.
      Leading underscore makes these properties private at checkout.
    */
    const buildId =
      'custom-' +
      Date.now() +
      '-' +
      Math.random().toString(36).slice(2, 8);

    buildProperties._CustomBuildId = buildId;
    buildProperties._ComponentType = 'Custom Iron Build';

    const items = [
      {
        id: Number(ironVariant.id),
        quantity: clubCount,
        properties: buildProperties
      }
    ];

    /*
      Only add a shaft helper line when there is an actual upcharge.
    */
    if (shaftUpchargeCents > 0) {
      items.push({
        id: Number(shaftVariant.id),
        quantity: clubCount,
        properties: {
          _CustomBuildId: buildId,
          _ComponentType: 'Shaft Upgrade',
          'Shaft Upgrade':
            shaftState.shaft?.shaft_name ||
            shaftState.shaft?.name ||
            'Custom Shaft Upgrade'
        }
      });
    }

    /*
      Only add a grip helper line when there is an actual upcharge.
    */
    if (gripUpchargeCents > 0) {
      items.push({
        id: Number(gripVariant.id),
        quantity: clubCount,
        properties: {
          _CustomBuildId: buildId,
          _ComponentType: 'Grip Upgrade',
          'Grip Upgrade':
            gripState.grip?.grip_name ||
            gripState.grip?.name ||
            'Custom Grip Upgrade'
        }
      });
    }

    const originalButtonText =
      addToCartButton?.textContent || 'Custom Order';

    try {
      if (addToCartButton) {
        addToCartButton.disabled = true;
        addToCartButton.textContent = 'Adding Custom Order...';
        addToCartButton.setAttribute('aria-busy', 'true');
      }

      const cartAddUrl =
        (window.Shopify?.routes?.root || '/') + 'cart/add.js';

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: items
        })
      });

      const result = await response.json();

      if (!response.ok) {
        console.error('Custom order cart error:', result);

        throw new Error(
          result.description ||
          result.message ||
          'Unable to add custom order to cart.'
        );
      }

      console.log('Custom order added:', result);

      window.location.href =
        (window.Shopify?.routes?.root || '/') + 'cart';
    } catch (error) {
      console.error('Unable to add custom order:', error);

      alert(
        error.message ||
        'Unable to add your custom order. Please try again.'
      );

      if (addToCartButton) {
        addToCartButton.disabled = false;
        addToCartButton.textContent = originalButtonText;
        addToCartButton.removeAttribute('aria-busy');
      }
    }
  });
}

updateHand();
applyProductHandSettings();
updateIrons();
updateBuildSummary();
updateCartProperties();
updatePolicyAgreement();

updateStepLockStates();
openStep(1);
  }

  function initializeAllConfigurators(container = document) {
    container
      .querySelectorAll('[data-golf-configurator]')
      .forEach(initializeGolfConfigurator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAllConfigurators()
    );
  } else {
    initializeAllConfigurators();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAllConfigurators(event.target);
    }
  );
  async function removeCustomBuild(buildId) {
  if (!buildId) return;

  const root = window.Shopify?.routes?.root || '/';

  try {
    const cartResponse = await fetch(root + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    });

    if (!cartResponse.ok) {
      throw new Error('Unable to load cart.');
    }

    const cart = await cartResponse.json();

    const matchingItems = cart.items.filter((item) => {
      return item.properties?._CustomBuildId === buildId;
    });

    if (!matchingItems.length) {
      throw new Error('Custom build could not be found in the cart.');
    }

    const updates = {};

    matchingItems.forEach((item) => {
      updates[item.key] = 0;
    });

    const updateResponse = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        updates: updates
      })
    });

    const updatedCart = await updateResponse.json();

    if (!updateResponse.ok) {
      console.error('Custom build removal response:', updatedCart);

      throw new Error(
        updatedCart.description ||
        updatedCart.message ||
        'Unable to remove custom build.'
      );
    }

    window.location.reload();

  } catch (error) {
    console.error('Remove Custom Build error:', error);

    alert(
      error.message ||
      'Unable to remove this custom build. Please try again.'
    );
  }
}

document.addEventListener('click', (event) => {
  const removeButton = event.target.closest(
    '.gc-remove-custom-build'
  );

  if (!removeButton) return;

  event.preventDefault();

  const buildId = removeButton.dataset.customBuildId;

  if (!buildId) {
    console.error('Remove Custom Build button has no build ID.');
    return;
  }

  const confirmed = window.confirm(
    'Remove this entire custom build from your cart?'
  );

  if (!confirmed) return;

  removeButton.disabled = true;
  removeButton.textContent = 'Removing...';

  removeCustomBuild(buildId);
});

})();